export const PRIVATE_KEY_MODULE_LABEL = 'Private key'
